"use strict";

require("core-js/modules/es6.object.to-string.js");

var objToString = Object.prototype.toString,
    id = objToString.call(function () {
  return arguments;
}());

module.exports = function (value) {
  return objToString.call(value) === id;
};